import React from 'react';
import { FlatList, Image, StyleSheet, Text, TextInput, TouchableOpacity, View } from 'react-native';

import { images } from '../../assets/images';
import { colors, fonts, scale } from '../../Styles';
import { history } from '../../util/History';
import { StudentListProps } from '../containers/StudentListContainer';
import { MNOHSDashboardWrapper } from '../MNOHSDashboardWrapper';
import { MNOHSFloatingIndicator } from '../MNOHSFloatingIndicator';

export const StudentListScreen: React.FC<StudentListProps> = ({
  searchTerm,
  isGettingStudents,
  students,
  studentSort,
  gradeSort,
  gpaSort,
  userClickedSort,
  userSubmittedSearchTerm,
  userChangedTerm,
  userClickedResetList,
}) => {
  return (
    <MNOHSDashboardWrapper headerTitle={'Overall Student List'}>
      <View style={styles.listHeaderContainer}>
        {/* input with search icon */}
        <View style={styles.inputWithIconContainer}>
          <Image source={images.searchIcon} style={styles.inputIcon} resizeMode="contain" />
          <TextInput
            value={searchTerm}
            onChangeText={userChangedTerm}
            placeholder="Search"
            style={styles.input}
            onSubmitEditing={e => userSubmittedSearchTerm(e.nativeEvent.text)}
          />
          <TouchableOpacity style={styles.xContainer} onPress={userClickedResetList}>
            <Image source={images.xIcon} style={styles.xIcon} />
          </TouchableOpacity>
        </View>

        {/* sorting */}
        <View style={styles.sortContainer}>
          {/* sort by student */}
          <TouchableOpacity
            style={[styles.sortItem, { flex: 4 }]}
            onPress={() => userClickedSort(studentSort === 'student-asc' ? 'student-dsc' : 'student-asc')}>
            <Text style={styles.sortText}>Student</Text>
            {studentSort === 'student-dsc' ? (
              <Image source={images.caretDownIcon} style={styles.sortIcon} resizeMode="contain" />
            ) : (
              <Image source={images.caretUpIcon} style={styles.sortIcon} resizeMode="contain" />
            )}
          </TouchableOpacity>

          {/* sort by grade */}
          <TouchableOpacity
            style={[styles.sortItem, styles.rightItem]}
            onPress={() => userClickedSort(gradeSort === 'grade-asc' ? 'grade-dsc' : 'grade-asc')}>
            <Text style={styles.sortText}>GRADE</Text>
            {gradeSort === 'grade-dsc' ? (
              <Image source={images.caretDownIcon} style={styles.sortIcon} resizeMode="contain" />
            ) : (
              <Image source={images.caretUpIcon} style={styles.sortIcon} resizeMode="contain" />
            )}
          </TouchableOpacity>

          {/* sort by gpa */}
          <TouchableOpacity
            style={[styles.sortItem, styles.rightItem]}
            onPress={() => userClickedSort(gpaSort === 'gpa-asc' ? 'gpa-dsc' : 'gpa-asc')}>
            <Text style={styles.sortText}>GPA</Text>
            {gpaSort === 'gpa-dsc' ? (
              <Image source={images.caretDownIcon} style={styles.sortIcon} resizeMode="contain" />
            ) : (
              <Image source={images.caretUpIcon} style={styles.sortIcon} resizeMode="contain" />
            )}
          </TouchableOpacity>

          {isGettingStudents && <MNOHSFloatingIndicator />}
        </View>
      </View>

      <FlatList
        style={styles.flatList}
        data={students}
        keyExtractor={(item, index) => item.firstName + item.lastName + item.gpa + index}
        renderItem={({ item }) => {
          return (
            <TouchableOpacity style={styles.itemContainer} onPress={() => history.push(`/student-record/${item.id}`)}>
              <Text style={[styles.itemText, { flex: 4 }]}>
                {item.firstName} {item.lastName}
              </Text>
              <Text style={[styles.itemText, styles.rightItem]}>{item.grade}</Text>
              <Text style={[styles.itemText, styles.rightItem]}>{item.gpa}</Text>
            </TouchableOpacity>
          );
        }}
      />
    </MNOHSDashboardWrapper>
  );
};

const styles = StyleSheet.create({
  listHeaderContainer: {
    paddingHorizontal: scale(16),
    paddingTop: scale(16),
    paddingBottom: scale(8),
  },
  inputWithIconContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    borderColor: colors.grayDark,
    borderWidth: 1,
    borderRadius: 8,
    backgroundColor: '#fff',
    marginRight: scale(4),
  },
  inputIcon: {
    marginHorizontal: scale(8),
    width: scale(14),
    height: scale(14),
  },
  input: {
    ...fonts.paragraph,
    flex: 1,
    paddingVertical: scale(8),
    paddingHorizontal: scale(4),
    outline: 'none',
  },
  itemContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#fff',
    paddingHorizontal: scale(16),
    paddingVertical: scale(12),
    marginVertical: scale(4),
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 2,
  },
  sortContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: scale(18),
  },
  sortItem: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  rightItem: {
    flex: 1,
    justifyContent: 'flex-end',
    textAlign: 'right',
  },
  sortText: {
    ...fonts.descriptionText,
    fontWeight: 'bold',
  },
  sortIcon: {
    marginLeft: scale(6),
    width: scale(14),
    height: scale(14),
  },
  itemText: {
    ...fonts.paragraph,
  },
  xContainer: {
    marginHorizontal: scale(8),
  },
  xIcon: {
    height: scale(14),
    width: scale(14),
  },
  flatList: {
    marginBottom: scale(52),
  },
});
